import { cloneDeep, each, isArray } from "lodash";
import { getTitleOfCopiedNode } from "../components/RightContextMenu/ContextActions/CopyAndPaste";
import { DATA_TYPE, FIELD_TYPE, OUTBOUND_OTHER_TYPE, RECORD_TYPE } from "../constants/datatypes";
import { eachDeep } from "deepdash-es/standalone";
import { t } from "i18next";
import { genKey, getUniqueWorkflowItemIdFromArray, isParentFieldGroup, isParentRepeatingFieldGroup, normalizeWorkflowVariableEncodedFieldsDeep } from "./utilFunctions";
import { getUpdatedData as getUpdatedDataInbound } from "../components/RightContextMenu/ContextActions/NewRecord";
import { getUpdatedData as getUpdatedDataOutbound } from "../components/RightContextMenu/ContextActions/NewRecordOutbound";

// FIELD GROUP valid Level
const FIELD_GROUP_LEVEL = {
  EDI: 1,
  MULIT_DELIMITED: 2,
  HL7: 2,
  DELIM_FLD_ID: 2
}


// Nodes Validation Function which verifies is destination valid or not
export const nodesValidation = (destinationNode, nodes, currentTab, isDragAndDrop, datatype, data, screenType) => {
  if (!nodes?.length) return;
  let modalMessage = "";
  let errorMessage = "";
  let isInside = false;

  let fieldTypeInclude = false;
  let fieldGroupIncluded = false;
  let recordTypeInclude = false;
  let bodyNodeSelected = false;
  let commentIncluded = false
  const topLevelRecord = screenType === "inbound" ? (currentTab === "body" && destinationNode?.key?.split('-')?.length <= 3) || 
                          (currentTab !== "body" && destinationNode?.key?.split('-')?.length <= 2) : destinationNode?.key?.split('-')?.length === 2;
  const {isFieldGroupParent, deepLevel, destinationNodeFieldGroup} = getFieldGroupState(destinationNode, data);
  const {isFieldGroupIncluded :FGIncluded, deepLevel : newDeepLevel} = checkFieldGroupIncludes(nodes);
  nodes.forEach((element) => {
    if (FIELD_TYPE[element?.ICON_DISPLAY]) fieldTypeInclude = true;
    if (RECORD_TYPE[element?.ICON_DISPLAY] && element.TYPE !== "QUERY") recordTypeInclude = true;
    if (element?.ICON_DISPLAY?.includes("COMMENT")) commentIncluded = true;
    if (element?.ICON_DISPLAY?.includes("FIELD_GROUP")) fieldGroupIncluded = true;
    if (element.ICON_DISPLAY === "TEMPLATE_BODY_DOTS") bodyNodeSelected = true;
  });

  const elseError = isElseErrorValidator(nodes);

  if( screenType === "workflow" ) {
    if (elseError) errorMessage = isDragAndDrop ? "BOX_CANNOT_MOVE_ITEM_MOVE_IF_NOT_ELSE" : "BOX_CANNOT_COPY_ITEM_COPY_IF_NOT_ELSE"

    else if(destinationNode?.key === "wf-0") isInside = true;
    else if(['LOOP_ITEM', 'CONDITION_IF', 'CONDITION_ELSE'].includes(destinationNode?.ICON_DISPLAY)) modalMessage = "BOX_LIKE_TO_PLACE_ELEM_INSIDE_CURR_ELEM_OR_DIRECTLY_AFTER";
    else isInside = false;
  }
  else if (elseError) errorMessage = isDragAndDrop ? "BOX_CANNOT_MOVE_ITEM_MOVE_IF_NOT_ELSE" : "BOX_CANNOT_COPY_ITEM_COPY_IF_NOT_ELSE"
  else if (topLevelRecord && screenType === "outbound") isInside = true ;
  else if (
    datatype === "XML" && !recordTypeInclude && 
    RECORD_TYPE[destinationNode?.ICON_DISPLAY] && 
    (destinationNode?.ICON_DISPLAY === "ELEMENT" || destinationNode?.ELEMENT_NAME)
  ) {
    if (nodes?.length === 1 && nodes?.[0]?.XML_ATTRIBUTE === "TRUE") {
      //for xml, solo attribute nodes go inside destination Element with no prompt
      isInside = true;
    } else {
      let hasNoAttributes = true;
      nodes?.forEach((e) => {
        //loop all selected nodes, and set flag to false if any is an attribute node
        if (e?.XML_ATTRIBUTE === "TRUE") hasNoAttributes = false;
      });
      if (hasNoAttributes) {
        //if all selected nodes no attributes, prompt user for inside or outside destination Element node
        modalMessage = "BOX_LIKE_TO_PLACE_ELEM_INSIDE_CURR_ELEM_OR_DIRECTLY_AFTER";
      } else {
        //if all selected nodes are attributes, place inside destination Element with no prompt
        isInside = true;
      }
    }
  }
  else if ((destinationNode?.ICON_DISPLAY === "TEMPLATE_BODY_DOTS" || (!destinationNode?.ICON_DISPLAY && currentTab !== "body")) && 
      (!recordTypeInclude || fieldGroupIncluded || fieldTypeInclude || commentIncluded || (["JSON", "XML"].includes(datatype) && screenType === "inbound"))) {
    errorMessage = ["JSON", "XML"].includes(datatype) ? "BOX_YOU_CANNOT_PLACE_OBJ_HERE"  : !recordTypeInclude ? "BOX_YOU_CANNOT_PLACE_FLD_HERE" : "BOX_YOU_CANNOT_PLACE_OBJ_HERE";
  }
  else if (destinationNode?.ICON_DISPLAY?.includes('FIELD_GROUP') && recordTypeInclude && deepLevel === 1) isInside = false;
  else if ((deepLevel >= 1 && !destinationNodeFieldGroup && recordTypeInclude) || (deepLevel > 1 && destinationNodeFieldGroup  && recordTypeInclude)) errorMessage = 'BOX_YOU_CANNOT_PLACE_OBJ_HERE'
  else if ((!destinationNode?.ICON_DISPLAY && currentTab !== "body") && recordTypeInclude) isInside = true;
  else if (destinationNode?.ICON_DISPLAY === "TEMPLATE_BODY_DOTS" && !fieldTypeInclude) isInside = true;
  else if ((bodyNodeSelected || checkDestinationValid(destinationNode?.nodeId, nodes)) && isDragAndDrop) errorMessage = "BOX_CANNOT_MOVE_ITEM_DEST_ITEM_IS_SUBITEM_OF_SRC_ITEM";
  else if (topLevelRecord && (fieldTypeInclude || fieldGroupIncluded || commentIncluded || currentTab !== "body" || ["JSON", "XML"].includes(datatype))) isInside = true;
  else if (topLevelRecord && !fieldTypeInclude) modalMessage = "BOX_LIKE_TO_PLACE_REC_INSIDE_CURR_REC_OR_DIRECTLY_AFTER";
  else if (isFieldGroupParent && recordTypeInclude && deepLevel > 1) errorMessage = "BOX_YOU_CANNOT_PLACE_OBJ_HERE";
  else if (destinationNodeFieldGroup && commentIncluded) errorMessage = "BOX_YOU_CANNOT_PLACE_OBJ_HERE";
  // Field Group nesting validation - MUST come before placement modal logic
  else if (FGIncluded && (
    // EDI: No field groups inside field groups at all 
    (datatype === "EDI" && deepLevel > 0 && !destinationNodeFieldGroup) || 
    // HL7/Multi-Delimited/DELIM_FLD_ID: Max 2 levels of nesting
    (["MULIT_DELIMITED", "HL7", "DELIM_FLD_ID"].includes(datatype) && (deepLevel + newDeepLevel) > FIELD_GROUP_LEVEL[datatype]) 
    // Additional validation: prevent nesting when destination is already at max level
    // (isFieldGroupParent && deepLevel >= FIELD_GROUP_LEVEL[datatype])
  )) {
    errorMessage = datatype === "EDI" ? "BOX_FIELD_GROUPS_LIMIT_OF_ONE" : "BOX_FIELD_GROUPS_LIMIT_OF_TWO";
  }
  // else if ((recordTypeInclude || fieldGroupIncluded || commentIncluded) && (fieldGroupIncluded && datatype !== "EDI") && (destinationNode?.ICON_DISPLAY?.includes('FIELD_GROUP') || destinationNode?.ICON_DISPLAY?.includes('REPEATING_FIELD_GROUP'))) {
  //   modalMessage = "BOX_LIKE_TO_PLACE_FLD_INSIDE_CURR_REC_OR_DIRECTLY_AFTER";
  // }
  else if ((recordTypeInclude || fieldGroupIncluded || commentIncluded) && screenType === "outbound" && ( destinationNode.ICON_DISPLAY === "REPEATING_FIELD_GROUP" || (FIELD_TYPE[destinationNode?.ICON_DISPLAY] && isParentRepeatingFieldGroup(data, destinationNode)))) {  
    // Pasting non-field items to a field within a field group 
    errorMessage = "BOX_THIS_ITEM_CAN_ONLY_CONTAIN_FIELDS";
  }
  else if ((recordTypeInclude || fieldGroupIncluded || commentIncluded) && (fieldGroupIncluded && datatype !== "EDI") && (destinationNode?.ICON_DISPLAY?.includes('FIELD_GROUP') || destinationNode?.ICON_DISPLAY?.includes('REPEATING_FIELD_GROUP'))) {
    modalMessage = "BOX_LIKE_TO_PLACE_FLD_INSIDE_CURR_REC_OR_DIRECTLY_AFTER";
  }
  else if (FGIncluded && destinationNodeFieldGroup && deepLevel === 1 && newDeepLevel === 1 && datatype !== "EDI") {
    modalMessage = "BOX_LIKE_TO_PLACE_FLD_INSIDE_CURR_REC_OR_DIRECTLY_AFTER";
  }
  else if ((destinationNode?.ICON_DISPLAY?.includes('FIELD_GROUP') || destinationNode?.ICON_DISPLAY?.includes('REPEATING_FIELD_GROUP')) && fieldTypeInclude && !recordTypeInclude && !fieldGroupIncluded && !commentIncluded) {
    // For pasting fields into field groups, default to inside 
    isInside = true;
  }
  else if (destinationNodeFieldGroup && fieldTypeInclude && !recordTypeInclude) modalMessage = "BOX_LIKE_TO_PLACE_FLD_INSIDE_CURR_REC_OR_DIRECTLY_AFTER";
  else if (FIELD_TYPE?.[destinationNode?.ICON_DISPLAY] && FIELD_TYPE?.[nodes?.[0]?.ICON_DISPLAY]) isInside = false;
  else if ((RECORD_TYPE?.[destinationNode?.ICON_DISPLAY] && destinationNode?.TYPE !== "QUERY") || ["CONDITION_IF", "CONDITION_ELSE"].includes(destinationNode?.ICON_DISPLAY) ) modalMessage = "BOX_LIKE_TO_PLACE_FLD_INSIDE_CURR_REC_OR_DIRECTLY_AFTER";
  return { modalMessage, errorMessage, isInside };
};

// This function will remove Nodes and Update Translated data in case of drag and drop;
export const removeNodesAndUpdateTransData = (data = [], keys = [], parentScreen, datatype, avoidNodeId, tab) => {
  const clonedData = cloneDeep(data) || [];
  let updatedData = [];
  let removedNodes = [];
  const validKeys = keys.filter((e, i) => {
    let child = false;
    keys.forEach((o, idx) => {
      if (
        i !== idx &&
        e.includes?.(o) &&
        e?.split("-")?.length > o?.split("-")?.length
      )
        child = true;
    });
    return !child;
  });
  
  const removeNodes = (data) => {
    return (
      data?.filter((e) => {
        const includeNode = !validKeys?.includes(e?.key);
        if (includeNode && e?.children?.length)
          e.children = removeNodes(e.children);
        if (!includeNode) removedNodes.push(e);
        return includeNode || e?.ICON_DISPLAY === "TEMPLATE_BODY_DOTS";
      }) || []
    );
  };
  const updateDataFunction = parentScreen === "inbound" ? getUpdatedDataInbound : getUpdatedDataOutbound
  updatedData = updateDataFunction(removeNodes(clonedData), datatype, avoidNodeId, parentScreen === "workflow", tab);
  return { updatedData, removedNodes };
};

// This function will add Nodes and Update Translated data in drag and drop and copy paste;
export const addNodesAndUpdateTransData = (
  data,
  nodes,
  destinationNode,
  isInside,
  datatype,
  currentTab,
  screenType,
  isDragAndDrop = false,
  isCopiedFromDifferentTemplate = false
) => {
  const clonedData = cloneDeep(data);
  let recordTypeNodes = [];
  let fieldTypeNodes = [];
  let toBeSelectedNode;
  const newSelectedKeys = [];
  const exactKey = getNewKey(data, destinationNode?.nodeId, destinationNode?.key, screenType, destinationNode?.ICON_DISPLAY, currentTab);
  const destinationParentKey = isInside ? exactKey : exactKey?.split('-')?.slice(0, -1)?.join('-');

  let allNodes = {};

  if (!destinationParentKey && currentTab === "body" && screenType === "inbound") return;
  const newId = getUniqueWorkflowItemIdFromArray(clonedData);
  const tempNodes = (screenType === "workflow" && !isDragAndDrop) ? getNodesWithNewIDs(nodes, newId) : nodes;
  tempNodes?.forEach( (e, i) => {
    if (screenType === "inbound" && RECORD_TYPE?.[e?.ICON_DISPLAY]) allNodes[i] = { node: e, type: 'record' };
    else if (screenType === "outbound" && RECORD_TYPE?.[e?.ICON_DISPLAY] && e?.TYPE !== "QUERY" ) {
      if (e?.ICON_DISPLAY?.includes("ELEMENT") && !e?.children?.length) {
        allNodes[i] = { node: e, type: 'field' };
      }else allNodes[i] = { node: e, type: 'record' };
    }else allNodes[i] = { node: e, type: 'field' };
  })

  const getFieldNumber = (data, datatype, key) => {
    let fieldNumber = datatype === "EDI" ? -1 : 0;
    for (let index = 0; index < data?.length; index++) {
      const e = data?.[index];
      fieldNumber = (datatype === "EDI" && e?.ICON_DISPLAY?.includes('FIELD_GROUP')) || FIELD_TYPE[e?.ICON_DISPLAY] ? fieldNumber + 1 : fieldNumber;
      if(e?.key === key) break;
    }
    return fieldNumber;
  }

  const fieldHandler = (data, e, i, startIndex, parentKey, fieldNumber) => {
    const copiedNodeTitle = getTitleOfCopiedNode(data, e);
    const title = FIELD_TYPE[e.ICON_DISPLAY] ? `${t(DATA_TYPE?.[datatype]?.field?.label)} ${copiedNodeTitle}` : copiedNodeTitle;
    // const mapName = FIELD_TYPE[e.ICON_DISPLAY] ? copiedNodeTitle : undefined;
    const key = `${isInside ? parentKey : destinationParentKey}-${startIndex + i}`;
    // const tempFieldNumber = (datatype === "EDI" && e?.ICON_DISPLAY?.includes('FIELD_GROUP')) || FIELD_TYPE[e?.ICON_DISPLAY] ? fieldNumber++ : undefined;
    const nodeId =genKey(title);
    let initialId = clonedData?.[0]?.ID;
    const newId = getUniqueWorkflowItemIdFromArray(clonedData);
    let nodeObj;
    if (OUTBOUND_OTHER_TYPE[e?.ICON_DISPLAY] || screenType === "outbound") {
      nodeObj = {
        ...e,
        key,
        nodeId: nodeId,
        // ...(screenType === "workflow" ? {ID: `${newId}`} : {})
      }
    }
    else if (screenType === "workflow" && e?.ICON_DISPLAY === "SEND_DATA") {
      nodeObj = {
        ...e,
        key,
        nodeId: nodeId,
        // ID: `${newId}`,
        // ...((isDragAndDrop || isCopiedFromDifferentTemplate)? {} : {OUTBOUND_ID: `${newId + 1}`} ),
        // OUTBOUND: {
        //   ...(e?.OUTBOUND || {}),
        //   ...((isDragAndDrop || isCopiedFromDifferentTemplate) ? {} : {ID: `${newId + 1}`}),
        // }
      }
    }
    else if (screenType === "workflow" && e?.ICON_DISPLAY !== "CALL_PLUGIN") {
      nodeObj = {
        ...e,
        key,
        nodeId: nodeId,
        // ID: `${newId}`
      }
    }
    else if (screenType === "workflow" && e?.ICON_DISPLAY === "CALL_PLUGIN") {
      nodeObj = {
        ...e,
        key,
        nodeId: nodeId,
        // ID: `${newId}`,
        title : copiedNodeTitle,
        NAME: copiedNodeTitle,

      }
    }
    else {
      nodeObj = {
        ...e, 
        key, 
        title : e?.ICON_DISPLAY === "COMMENT" ? e?.title : ["ATTRIBUTE", "FIELD_GROUP"].includes(e?.ICON_DISPLAY) ? copiedNodeTitle : title,
        MAPNAME: copiedNodeTitle, 
        DESCRIPTION: copiedNodeTitle, 
        ATTRIBUTE_NAME:datatype === "XML" && FIELD_TYPE[e.ICON_DISPLAY] ? copiedNodeTitle : undefined,
        children: e?.children || [],
        nodeId: nodeId,
      };
    }
    generateNewAlternateNodeId(nodeObj);
    if (e?.ICON_DISPLAY?.includes('FIELD_GROUP')) nodeObj['TYPE'] = copiedNodeTitle;
    nodeObj = updateNodeAccordingToDataType(nodeObj, datatype, screenType, currentTab);
    data?.splice(startIndex + i, 0, nodeObj);
    const newFieldNumber = getFieldNumber(data, datatype, key, e);
    if ((datatype === "EDI" && e?.ICON_DISPLAY?.includes('FIELD_GROUP')) || FIELD_TYPE[e?.ICON_DISPLAY]) nodeObj.fieldNumber = newFieldNumber
    nodeObj.key = getNewKey(clonedData, nodeObj?.nodeId, nodeObj?.key, screenType, nodeObj?.ICON_DISPLAY, currentTab);
    toBeSelectedNode = nodeObj;
  }

  const recordHandler = (data, e, i, isEmptyData, parentKey, startIndex =   0) => {
    const recordInsertingPosition = getRecordInsertingPosition(data, toBeSelectedNode?.key ? toBeSelectedNode?.key : destinationNode?.key, isInside, "inbound");
    const title = getTitleOfCopiedNode(data, e);
    const key = `${isEmptyData ? (screenType === "inbound" ? 'ib' : screenType === "workflow" ? "wf" : {header: "obh", body: "ob", trailer: "obt"}[currentTab]) : isInside ? parentKey :destinationParentKey}-${startIndex + i}`
    const nodeId =genKey(title);
    let nodeObj;
    
    if(screenType === "outbound") {
      nodeObj={
        ...e,
        key
      }
    }
    else {
      nodeObj= {
        ...e, 
        key, 
        title: `${title}${isEmptyData ? "_" + t(currentTab?.toUpperCase()): ''}`, 
        TYPE: `${title}${isEmptyData ? "_" + t(currentTab?.toUpperCase()): ''}`, 
        ICON_DISPLAY:DATA_TYPE?.[datatype]?.record?.icon,
        ELEMENT_NAME: datatype === "XML" ? title : undefined,
        children: e?.children || []
      };
        
    }
    nodeObj["nodeId"] = nodeId;
    generateNewAlternateNodeId(nodeObj);
    nodeObj =  updateNodeAccordingToDataType(nodeObj, datatype, screenType, currentTab);
    if (isEmptyData) {
      data.push(nodeObj);
    }
    else {
      data?.splice(startIndex + i, 0, nodeObj);
    }
    nodeObj.key = getNewKey(clonedData, nodeId, nodeObj?.key, screenType, nodeObj?.ICON_DISPLAY, currentTab);
    toBeSelectedNode = nodeObj;
    newSelectedKeys.push(nodeObj?.key);
  }

  if (!clonedData.length && Object.keys(allNodes)?.length) {
    const parentKey = getParentKey(destinationNode?.key, clonedData, screenType, currentTab)
    if (allNodes[0]?.type === 'record') {
      recordHandler(clonedData, allNodes[0].node, 0, true);
      clonedData[0].children = [...clonedData?.[0].children || []];
      let startIndex = isInside ? 0 : getStartIndex(exactKey, []);
      for (let i = 0; i  < Object.keys(allNodes).length - 1; i++) {
        const e = allNodes[i];
        if (e?.type === 'record') {
          recordHandler(clonedData[0].children, e?.node || {}, i - 1,false, parentKey, startIndex)
        }
      }
    }
  }else {
    let found = false;
    const parentKey = getParentKey(destinationNode?.key, clonedData, screenType, currentTab)
    eachDeep(clonedData, (obj) => {
      if (found) return;
      if (obj && obj?.key && obj?.key === destinationParentKey) {
          found = true;
          obj.children = [...obj?.children || []];
          let startIndex = isInside ? 0 : getStartIndex(exactKey, obj?.children);
          for (let i = 0; i  < Object.keys(allNodes).length; i++) {
            const e = allNodes[i];
            if (e?.type === 'field') {
              fieldHandler(obj?.children, e?.node || {}, i, startIndex, parentKey)
            }else {
              recordHandler(obj?.children, e?.node || {}, i ,false, parentKey, startIndex)
            }
          }
          obj.children = [...obj?.children || []];
      }
      data = obj?.children || []
    })
  }

  if ((screenType === "workflow" || screenType === "outbound") && clonedData?.length) {
    normalizeWorkflowVariableEncodedFieldsDeep(clonedData);
  }

  return {translatedData: clonedData, selectedNode: toBeSelectedNode, newSelectedKeys};
};

// This will get parent key;
const getParentKey = (key, data, screenType, currentTab) => {
  let result = '';
  const keyPrefix = {inbound: "ib", outbound: {header: "obh", body: "ob", trailer: "obt"}[currentTab], workflow: "wf"}[screenType];
  const loopData = (data, parentKey) => {
    for (let i = 0; i<data.length; i++){
      const e = data[i];
      if (e?.key === key) result = parentKey + '-' + i;
      if (e?.children?.length) {
        loopData(e.children, parentKey+'-'+i);
      }
    }
  }
  loopData(data, keyPrefix)
  return result;
}

// This function will get Inserting Position for Record
export const getRecordInsertingPosition = (translatedData = [], key, isInside) => {
  const data = cloneDeep(translatedData);
  if (!key) return 0;
  // if (isInside){
  //     for (let i = 0; i < data.length ; i++ ){
  //         if (RECORD_TYPE[data?.[i]?.ICON_DISPLAY]) return i;
  //     }
  //     return data.length ? data.length : 0;
  // }
  // else  {
      let foundIndex;
      for (let i = 0; i < data.length ; i++ ){
          if (RECORD_TYPE[data?.[i]?.ICON_DISPLAY] && key === data?.[i]?.key) {
            return i + 1;
          }
          if (RECORD_TYPE[data?.[i]?.ICON_DISPLAY] && !foundIndex) {
            foundIndex = i;
          }
      }
      if (foundIndex) return foundIndex;
      return data.length ? data.length : 0;
  // }
}

export const getStartIndex = (key, data) => {
  let index = 0;
  data.forEach((e, i) => {
    if(e?.key === key) index = i;
  })
  return index + 1;
}

// This Function is to check if we are placing any node inside of its sub node.
export const checkDestinationValid = (destinationNodeId, nodes) =>{
  const loopCheck = (data = []) => {
    for(let i = 0; i< data.length ; i++) {
      if (data[i].nodeId === destinationNodeId) return true;
      if (data?.[i]?.children?.length && loopCheck(data?.[i]?.children)) return true;
    }    
  }
  return loopCheck(nodes) || false;
}

// This will check field group validation;
export const checkFieldGroupIncludes = (nodes) => {
  let isFieldGroupIncluded = false;
  let deepLevel = 0;

  const getDeepLevel = (node) => {
    let level = 0;
    const loopNode = (node) => {
      if (node.ICON_DISPLAY.includes("FIELD_GROUP")) level++; 
      if (node?.children?.length) {
        node?.children?.forEach( o => {
          loopNode(o);
        })
      }
    }
    loopNode(node);
    return level
  }

  const loopCheck = (data = []) => {
    for(let i = 0; i< data.length ; i++) {
      if (data?.[i]?.ICON_DISPLAY?.includes("FIELD_GROUP")) {
        isFieldGroupIncluded = true;
        deepLevel = Math.max(getDeepLevel(data[i]), deepLevel);
      }
      if (data?.[i]?.children?.length) loopCheck(data?.[i]?.children)
    }    
  }
  loopCheck(nodes);
  return {isFieldGroupIncluded, deepLevel};
}

// THis function will get field group states like nested level and other states
const getFieldGroupState = (selectedNode, translatedData) => {
  const keyParts = selectedNode?.key?.split("-") || [];
  let isFieldGroupParent = false;
  let deepLevel = 0;
  let destinationNodeFieldGroup = selectedNode.ICON_DISPLAY?.includes('FIELD_GROUP');
  let data = translatedData;
  
  // Skip the first part (ib/ob/etc) and traverse the tree
  for (let i = 1; i < keyParts.length; i++) {
    const index = parseInt(keyParts[i]);
    if (data && data[index]) {
      const node = data[index];
      if (node?.ICON_DISPLAY?.includes("FIELD_GROUP")) {
        isFieldGroupParent = true;
        deepLevel++;
      }
      data = node.children || [];
    }
  }
  return { isFieldGroupParent, deepLevel , destinationNodeFieldGroup};
};

const cleanNodeJSON = (node) => { 
  Object.keys(node)?.forEach(key => {
    if (!node[key] && node?.hasOwnProperty(key)) delete node?.[key];
  })
}

// This function will update nodes according to data types
export const updateNodeAccordingToDataType = (node , datatype, screenType, currentTab) =>{
  const clonedNode = cloneDeep(node);
  const loopUpdate = (node, datatype) => {
    if (RECORD_TYPE[node?.ICON_DISPLAY] || 
        (node?.ICON_DISPLAY?.includes('FIELD_GROUP') && !['DELIM_FLD_ID', 'MULIT_DELIMITED', 'EDI', 'HL7'].includes(datatype))) {
      if (datatype === "XML" && screenType === "outbound" && currentTab !== "body") {
        node = node;
      }
      else if (node.ICON_DISPLAY.includes("ELEMENT") && datatype !== "XML") {
        node['title'] = `${(node.MAPNAME || node.ELEMENT_NAME || node.TYPE || t('UNNAMED'))?.replace('<')?.replace('>')}`;
        node['TYPE'] = (node.ELEMENT_NAME || node.TYPE || t('UNNAMED'))?.replace('<')?.replace('>')
        node.ICON_DISPLAY = node?.children.length ? (screenType === "outbound" && node?.LOOP_SOURCE_NAME) ? "RECORD_LOOP" : DATA_TYPE[datatype]?.record.icon : DATA_TYPE[datatype]?.field.icon;
        if (node?.hasOwnProperty('ELEMENT_NAME')) delete node.ELEMENT_NAME;
        if (node?.hasOwnProperty('ATTRIBUTE_NAME')) delete node.ATTRIBUTE_NAME;
      }
      else if (datatype !== "XML" && (node.ICON_DISPLAY === "ELEMENT" || node.ICON_DISPLAY === "REPEATING_ELEMENT")) {
        // When changing FROM XML to other data types, set title to loop record value
        const loopRecordValue = node.LOOP_SOURCE_NAME || node.SOURCE_TYPE || node.TYPE;
        if (loopRecordValue && loopRecordValue !== t("SELECT")) {
          node['title'] = `${t("LBL_RECORD")} ${loopRecordValue}`;
        } else {
          node['title'] = `${t("LBL_RECORD")} ${node.MAPNAME || node.ELEMENT_NAME || t('UNNAMED')}`;
        }
      }
      else if (datatype === "XML") {
          if(node?.XML_RECORD !== "TRUE") {
          node.ICON_DISPLAY = (node.LOOP_SOURCE_NAME && !["INBOUND_DATA", "SELECT" , t("SELECT")].includes(node.LOOP_SOURCE_NAME)) ? RECORD_TYPE.REPEATING_ELEMENT.icon  : RECORD_TYPE.ELEMENT.icon ;
          // Only set ELEMENT_NAME if it doesn't already exist and avoid using TYPE for root nodes
          if (!node.ELEMENT_NAME) {
            node.ELEMENT_NAME = node.MAPNAME || 'UNNAMED_ELEMENT';
          }
          // Set title to use ELEMENT_NAME (which now contains the proper XML_BODY_NAME value)
          node['title'] = `<${node.ELEMENT_NAME}>`;
        }
      }
      else if(screenType === "outbound" && datatype === "DATABASE" && node?.TYPE !== "QUERY"){
        node.ICON_DISPLAY = node?.STATEMENT ? RECORD_TYPE.QUERY.icon : RECORD_TYPE.RECORD_LOOP.icon;
      }else if (screenType === "outbound" && node?.ICON_DISPLAY === "QUERY") {
        // node.ICON_DISPLAY = node.ICON_DISPLAY;
      }else if (screenType === "outbound" && (node?.MAPNAME || node?.LOOP_SOURCE_NAME) && (node?.RECORD_TYPE || node?.SOURCE_TYPE)){
        node.ICON_DISPLAY = RECORD_TYPE.RECORD_LOOP.icon;
      }else {
        node.ICON_DISPLAY = DATA_TYPE[datatype]?.record.icon
      }


      if (!Object.keys(node?.EDIT_RULE || {}).length && screenType === "outbound"){
        node.EDIT_RULE =[
            {
               "TYPE" : "RECORD_RULE"
            }
         ]
      }

      if ((node?.ICON_DISPLAY === "RECORD" || node?.ICON_DISPLAY === "RECORD_LOOP") && screenType === "outbound"){
        if (node.hasOwnProperty("CONDITION")) delete node.CONDITION
      }
      
      
    } 
    else if (FIELD_TYPE[node?.ICON_DISPLAY]) {
      if (datatype === "XML" && screenType === "outbound" && currentTab !== "body") {
        node['title'] = `${t("LBL_FIELD")} ${node.MAPNAME || node.ATTRIBUTE || node.ELEMENT_NAME || node.DESCRIPTION}`;
        node.DESCRIPTION = node.MAPNAME || node.ATTRIBUTE || node.ELEMENT_NAME || node.DESCRIPTION;
        node.ICON_DISPLAY = node.REPEATING === "TRUE" ? "FIELD_LOOP" : "FIELD";
      }
      else if (datatype === "XML") {
        if (node.ICON_DISPLAY === "ATTRIBUTE") {
          node['title'] = `${node.DESCRIPTION || node.ATTRIBUTE_NAME || node.MAPNAME ||  node.TYPE}`;
          node['ATTRIBUTE_NAME'] = node.DESCRIPTION || node.ATTRIBUTE_NAME || node.MAPNAME  || node.TYPE
        }
        else {
          node['title'] = `<${node.DESCRIPTION || node.ELEMENT_NAME || node.MAPNAME ||  node.TYPE}>`;
          node['ELEMENT_NAME'] = node.DESCRIPTION || node.ELEMENT_NAME || node.MAPNAME  || node.TYPE
        }
        node.ICON_DISPLAY = node.ICON_DISPLAY === "ATTRIBUTE" ? "ATTRIBUTE" : "ELEMENT";
      }
      else if (node.ICON_DISPLAY.includes("ATTRIBUTE")) {
        node['title'] = `${t("LBL_FIELD")} ${node.MAPNAME || node.ATTRIBUTE || node.ELEMENT_NAME}`;
      }
      else if (node?.type === "FIELD_LOOP" && ["HL7", "DELIM_FLD_ID", "MULIT_DELIMITED"].includes(datatype)) {
        node.ICON_DISPLAY = "FIELD_LOOP";
      }
      else node.ICON_DISPLAY = DATA_TYPE[datatype]?.field.icon
    }else if (["FIELD_GROUP", "REPEATING_FIELD_GROUP"].includes(node?.ICON_DISPLAY) && screenType === "outbound"){
      if (datatype === "HL7"){
        if (node.ICON_DISPLAY === "REPEATING_FIELD_GROUP")  {
          node.FIELD = node.FIELD ||{
              "FIELDTYPE" : "CONSTANT",
              "ICON_DISPLAY" : "FIELD_LOOP",
              "REPEATING" : "TRUE"
          }
          node.LOOP = node.LOOP || "MULTI"
        }else  {
          node.FIELD = node.FIELD ||{
            "FIELDTYPE" : "CONSTANT",
          }
          node.LOOP = "SINGLE"
        }
      }
      if (node.ICON_DISPLAY === "REPEATING_FIELD_GROUP") {
        node.LOOP = node.LOOP || "MULTI"
        node.REPEATING = "TRUE"
      }else {
        node.LOOP = "SINGLE"
      }
    }
    node['nodeId'] = genKey();
    cleanNodeJSON(node);
    if (node?.children?.length && isArray(node.children)) {
      node.children.forEach(e => {
        loopUpdate(e, datatype)
      })
    }
  }
  loopUpdate(clonedNode, datatype);
  return clonedNode;
}


export const isElseErrorValidator = (nodes) => {
  const ifNodes = nodes?.filter?.(e => e?.ICON_DISPLAY === "CONDITION_IF");
  const elseNodes = nodes?.filter?.(e => e?.ICON_DISPLAY === "CONDITION_ELSE");
  if(elseNodes?.length > ifNodes) return true;
  for(let i = 0; i< elseNodes?.length; i++ ){
    let found = false;
    for(let j = 0; j < ifNodes.length; j++){
      if(elseNodes[i]?.nodeId === ifNodes[j]?.nodeId) {
        found = true;
        break;
      }
    }
    if (!found) return true;
  }
  return false;
}

const getNewKey = (data, nodeId, key, screenType, ICON_DISPLAY, currentTab) => {
  let newKey = '' // 'ib' for now but can change later for outbound and other workflow;
  let exitLoop = false;
  const loopNode = (data, currentKey) => {
    each(data, (item, index, arr) => {
      if (exitLoop) return false;
      const tempKey = currentKey + '-' + (index === undefined || index === null) ? 0 : index;
      if (item.ICON_DISPLAY === ICON_DISPLAY && item.nodeId === nodeId) {
        exitLoop = true;
        newKey = tempKey;
        return;
      }
      if (exitLoop) return false;
      if (item.children) loopNode(item.children, tempKey);
    })
  }
  const keyPrefix = {inbound: "ib", outbound: {header: "obh", body: "ob", trailer: "obt"}[currentTab], workflow: "wf"}[screenType];
  loopNode(data, keyPrefix);
  return newKey ? newKey : key;
}

const generateNewAlternateNodeId = (node) => {
  try {
    node.alternateNodeId = genKey();
  } catch (error) {
    // Handle the case where the property cannot be assigned
    console.warn('Unable to assign alternateNodeId to node:', error.message);
  }
  if (node?.children?.length && isArray(node.children)) {
    node.children.forEach(e => {
      generateNewAlternateNodeId(e);
    });
  }
};

/** Rewrite embedded workflow-item id refs when pasted nodes receive new IDs (desktop workbench parity). */
const remapEmbeddedWfItemIdRefs = (nodes, oldId, newId) => {
  if (oldId == null || oldId === "" || newId == null || newId === "") return;
  const oldStr = String(oldId);
  const newStr = String(newId);
  if (oldStr === newStr) return;
  const keys = ["WF_ITEM_ID", "WF_ITEM_ID_1", "WF_ITEM_ID_2"];
  const walk = (obj) => {
    if (obj == null || typeof obj !== "object") return;
    if (Array.isArray(obj)) {
      obj.forEach(walk);
      return;
    }
    Object.keys(obj).forEach((k) => {
      if (keys.includes(k)) {
        const v = obj[k];
        if (v != null && v !== "" && String(v) === oldStr) obj[k] = newStr;
      } else {
        walk(obj[k]);
      }
    });
  };
  walk(nodes);
};

const getNodesWithNewIDs = (nodes = [], newId) => {
  let idCounter = newId;
  const nodesIDMax = getUniqueWorkflowItemIdFromArray(nodes);
  if (idCounter <= nodesIDMax) idCounter = nodesIDMax + 1; 
  const clonedNodes = cloneDeep(nodes);
  const findAndUpdateIDs = (ID, newIdValue, nodesToSearch, isGetData = false) => {
    nodesToSearch?.forEach(e => {
      if (isGetData) {
        if (e?.ICON_DISPLAY === "TRANSLATE" && e?.INBOUND_ID === ID) {
          e.INBOUND_ID = `${newIdValue}`;
        }
      }else {
        if (e?.OUTBOUND_ID === ID) {
          e.OUTBOUND_ID = `${newIdValue}`;
          e.OUTBOUND = { ...(e?.OUTBOUND || {}), ID: `${newIdValue}` };
        }
        if (e?.ICON_DISPLAY === "TRANSLATE") {
          e.CONDITIONAL_TEMPLATE = e?.CONDITIONAL_TEMPLATE?.map(ct => {
            ct.OUTBOUND_CONDITION = ct?.OUTBOUND_CONDITION?.map(oc => {
              if (oc?.OUTBOUND_ID === ID) {
                oc.OUTBOUND_ID = `${newIdValue}`;
              }
              return oc;
            });
            return ct;
          })

        }
      }
      if (e?.children?.length) {
        findAndUpdateIDs(ID, newIdValue, e.children, isGetData);
      }
    });
  };

  const loopAndAssignIDs = (nodes) => {
    nodes?.forEach(e => {
      const ID = e?.OUTBOUND_ID;
      if (ID) findAndUpdateIDs(ID, idCounter, clonedNodes);
      const previousID = e?.ID;
      idCounter = idCounter + 1;
      e.ID = `${idCounter}`;
      if (e?.ICON_DISPLAY === "GET_DATA") findAndUpdateIDs(previousID, idCounter, clonedNodes, true);
      if (previousID != null && previousID !== "") remapEmbeddedWfItemIdRefs(clonedNodes, previousID, idCounter);
      idCounter++;
      if (e?.children?.length) loopAndAssignIDs(e.children);
    });
  }
  loopAndAssignIDs(clonedNodes);
  return clonedNodes;
}